import React from 'react';

import CmsPromotionCarousel from '../../../../components/cms-promotion-carousel/cms-promotion-carousel';

import { GET_PROMOTIONS } from '../../graphql/store-detail-queries';

import { useQuery } from '../../../../shared/hooks/hooks';

import styles from './store-promos.scss';

function StorePromos() {
  const { data } = useQuery(GET_PROMOTIONS);

  const { contentSlots } = data?.cms?.page || {};
  let promoData = null;

  const typeName = 'CmsPromotionCarouselSectionComponent';

  if (contentSlots) {
    for (let section of contentSlots.reverse()) {
      const found = section?.cmsComponents?.find(
        c => c.__typename === typeName
      );
      if (found) promoData = found;
    }
  }

  return promoData ? (
    <div className={styles['promos']}>
      <CmsPromotionCarousel {...promoData} />
    </div>
  ) : null;
}

export default StorePromos;
